<template>
	<!-- 时间线组件 -->
	<div class="timeline">
		<div class="timeline_title">
			<div class="timeline_at_for"  v-for="(item, index) in cycle"
				:key="index">
				<div class="timeline_at_for_backimg" :class="{ timeline_at_for_at: item.isshow }">
						{{item.isshow?'当前生长阶段':''}}
				</div>
			

			</div>
		</div>
		<div class="timeline_nav">
			<div class="nav_boder" v-for="(item, index) in cycle" :key="index">
				<div class="line"></div>
				<div class="circular" :class="{  circular_active: active === item.index }" @click="Changeactive(item.index)">
					<div class="circular-circular" :class="{  circular_circular_active: active === item.index }"></div>
				</div>
				<div class="line"></div>
			</div>
		</div>
		<div class="timeline_title">
			<div class="timeline_title_for" v-for="(item, index) in cycle" :key="index" :class="{  timeline_title_for_active: active === item.index }">
				{{item.title}}<br />{{formatDate(item.starttimer)}} 至 {{formatDate(item.endtimer)}}
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		onMounted,
		ref,defineEmits
	} from 'vue';
	
	let  active=ref(0)
	let  changeindex=ref(0)
	const currentDate = new Date();// 获取当前日期
	const currentMonth = currentDate.getMonth() + 1; // 月份从0开始，因此需要加1
	const currentDateOfMonth = currentDate.getDate();
	const nowdate=new Date(currentDate.getFullYear() - 1, currentMonth, currentDateOfMonth);
	const cycle = ref([{
			title: '休眠期',
			starttimer: new Date(currentDate.getFullYear() - 1, 11, 11), // 12月11日，
			endtimer: new Date(currentDate.getFullYear(), 0, 31), // 1月31日
			isshow: false,
			index:1,
		},
		{
			title: '春季根系活动期',
			starttimer: new Date(currentDate.getFullYear(), 1, 1),
			endtimer: new Date(currentDate.getFullYear(), 2, 31),
			isshow: false,
			index:2,
		},
		{
			title: '萌芽·展叶·新梢生长期',
			starttimer: new Date(currentDate.getFullYear(), 3, 1),
			endtimer: new Date(currentDate.getFullYear(), 4, 10),
			isshow: false,
			index:3,
		},
		{
			title: '开花坐果期',
			starttimer: new Date(currentDate.getFullYear(), 4, 11),
			endtimer: new Date(currentDate.getFullYear(), 5, 10),
			isshow: false,
			index:4,
		},
		{
			title: '果实膨大期',
			starttimer: new Date(currentDate.getFullYear(), 5, 11),
			endtimer: new Date(currentDate.getFullYear(), 6, 31),
			isshow: false,
			index:5,
		},
		{
			title: '果实转色期',
			starttimer: new Date(currentDate.getFullYear(), 7, 1),
			endtimer: new Date(currentDate.getFullYear(), 7, 20),
			isshow: false,
			index:6,
		},
		{
			title: '果实成熟期',
			starttimer: new Date(currentDate.getFullYear(), 7, 21),
			endtimer: new Date(currentDate.getFullYear(), 8, 10),
			isshow: false,
			index:7,
		},

		{
			title: '枝条成熟期',
			starttimer: new Date(currentDate.getFullYear(), 8, 11),
			endtimer: new Date(currentDate.getFullYear(), 9, 31),
			isshow: false,
			index:8,
		},

		{
			title: '落叶期',
			starttimer: new Date(currentDate.getFullYear(), 10, 1),
			endtimer: new Date(currentDate.getFullYear(), 11, 10),
			isshow: false,
			index:9,
		},
	])
	
	const emit = defineEmits(['selectperiod']);
	onMounted(()=>{
		for (let i = 0; i < cycle.value.length; i++) {
		    const item = cycle.value[i];
		    if (currentDate >= item.starttimer && currentDate <= item.endtimer) {
		        item.isshow = true;
		        changeindex.value = i;
				active.value=i+1;
		        break; // 如果找到了当前时间段，就跳出循环
		    }
		}
		Changeactive(active.value); // 触发自定义事件，将 active 传递给父组件
	})

	if (currentMonth == 12) {
		cycle.value[0].starttimer = new Date(currentDate.getFullYear(), 11, 11); // 1月31日
		cycle.value[0].endtimer = new Date(currentDate.getFullYear() + 1, 0, 31); // 1月31日
	}
	
	function Changeactive(e){
		active.value=e;
		emit('selectperiod', active.value); // 触发自定义事件，将 active 传递给父组件
	}

	function formatDate(date) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补全两位数
		const day = String(date.getDate()).padStart(2, '0'); // 补全两位数

		return `${month}-${day}`;
	}
</script>

<style scoped>
	.timeline_nav {
		width: 90%;
		/* 调整时间线宽度 */
		display: flex;
		justify-content: space-between;
		/* 使子元素等分 */
		margin: auto;
		/* 居中对齐 */
	}

	.nav_boder {
		display: flex;
		flex-direction: row;
		/* 纵向排列 */
		align-items: center;
		/* 水平居中 */
	}

	.line {
		height: 5px;
		width: 86px;
		/* 固定宽度 */
		background-color: #105d4b;
	}

    .circular {
		height: 20px;
		width: 20px;
		background-color: #105d4b;
		border-radius: 50%;
		/* 确保圆形 */
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 5px 0;
		/* 上下间距 */
	} 
	.circular_active {
		background-color: #00bf94;
	}
	

	.circular-circular {
		height: 10px;
		width: 10px;
		background-color: #00a580;
		border-radius: 50%;
		/* 确保圆形 */
	}
	.circular_circular_active{
		background-color: #74ffe0;
	}

	.timeline_title {
		color: #00a580;
		text-align: center;
		line-height: 20px;
		display: flex;
		justify-content: space-between;
		/* 等分标题 */
		width: 90%;
		/* 调整宽度 */
		margin: auto;
		/* 居中对齐 */
	}
	
	

	.timeline_title_for {
		width: 192px;
		/* 调整每个标题的宽度 */
	}
	.timeline_title_for_active{
		color:#2dffd0;
	}

	.timeline_at_for {
		height: 33px;
		width: 192px;
		/* 调整每个标题的宽度 */
		.timeline_at_for_backimg{
			height: 33px;
			width: 104px;
			margin: 0 auto;
			color: black;
			font-size: 13px;
			line-height: 25px;
		}
		.timeline_at_for_at {
			background-image: url('../../../assets/model/pr.png');
			background-repeat: no-repeat;
		}
	}

	
</style>